import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Typography, CircularProgress, Box } from "@mui/material";
import axios from "axios";

const PrimarySourcePage = () => {
  const { id } = useParams();
  const [source, setSource] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchPrimarySource = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_PRIMARY_SOURCES_API_URI}/api/primary_sources`,
          {
            params: { ids: id },
          }
        );

        // Check the structure of the data and access the 'primary_sources' array
        if (
          response.data.primary_sources &&
          response.data.primary_sources.length > 0
        ) {
          const matchingSource = response.data.primary_sources.find(
            (primarySource) => String(primarySource.id) === String(id)
          );

          if (matchingSource) {
            setSource(matchingSource);
          } else {
            setError("Primary source not found.");
          }
        } else {
          setError("Primary source not found.");
        }
      } catch (err) {
        console.error(err);
        setError("An error occurred while fetching the primary source.");
      } finally {
        setLoading(false);
      }
    };

    fetchPrimarySource();
  }, [id]);

  if (loading) {
    return (
      <Container style={{ textAlign: "center", marginTop: "50px" }}>
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container style={{ textAlign: "center", marginTop: "50px" }}>
        <Typography variant="h6" color="error">
          {error}
        </Typography>
      </Container>
    );
  }

  return (
    <Container style={{ marginTop: "50px" }}>
      <Typography variant="h4" gutterBottom>
        {source.title}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {source.description}
      </Typography>
      <Box mt={2}>
        <video width="100%" controls>
          <source src={source.url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </Box>
      <Box mt={2}>
        <Typography variant="body2">
          Transcription:{" "}
          <a href={source.content} target="_blank" rel="noopener noreferrer">
            View Transcription
          </a>
        </Typography>
      </Box>
    </Container>
  );
};

export default PrimarySourcePage;
